import React from "react";

const Terms = () => {
  return (
    <div style={container}>
      <h1>Terms & Conditions</h1>
      <p>Last updated: January 2026</p>

      <h3>1. Introduction</h3>
      <p>
        These Terms and Conditions govern your use of our application.
      </p>

      <h3>2. User Responsibilities</h3>
      <p>
        You agree to use the application only for lawful purposes.
      </p>

      <h3>3. Termination</h3>
      <p>
        We reserve the right to terminate access at any time.
      </p>
    </div>
  );
};

const container = {
  maxWidth: "800px",
  margin: "auto",
  lineHeight: "1.6",
};

export default Terms;
